/**
 * Scarica un PDF autenticato via API (blob).
 */
export async function downloadPdf(api, path, filename = 'documento.pdf') {
  const response = await api.get(path, { responseType: 'blob' });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
